import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import Api from './plugins/api'
import Axios from './plugins/axios'
import VueCookie from 'vue-cookie'
import VueGtag from 'vue-gtag'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import vuetify from './plugins/vuetify'
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';



Vue.use(Axios)
Vue.use(Api)
Vue.use(VueCookie)
if(process.env.VUE_APP_UA_TOKEN || process.env.VUE_APP_GA4_TOKEN){
  Vue.use(VueGtag, {
    includes: [
			{ id: process.env.VUE_APP_UA_TOKEN },
			{ id: process.env.VUE_APP_GA4_TOKEN }
		]
  }, router)
}
else{console.info('no Analytics tracking')}
Vue.use(FloatingVue)

// https://github.com/Maronato/vue-toastification/tree/main#toast-types
const toastOptions = {

}
Vue.use(Toast, toastOptions)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
